import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHead from '@/components/feature/SEOHead';
import Hero from './components/Hero';
import CategoryCards from './components/CategoryCards';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';
import { siteInfo } from '@/mocks/siteData';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: siteInfo.name,
  url: 'https://shiroi-jk.com',
  description: siteInfo.description,
  inLanguage: 'zh-CN',
  publisher: {
    '@type': 'Organization',
    name: siteInfo.name,
    url: 'https://shiroi-jk.com',
  },
};

const faqJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: '白丝JK手办的推荐购买渠道有哪些？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '推荐通过日本直邮渠道如Amiami、HobbySearch购买，价格透明且保证正品。国内渠道推荐Bilibili会员购、Hpoi和电玩男。',
      },
    },
    {
      '@type': 'Question',
      name: '如何辨别白丝JK手办的真伪？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '主要从五个方面辨别：包装盒印刷质量、涂装细节（特别是白丝部分）、底座logo与编号、价格是否过低、以及购买渠道是否可靠。',
      },
    },
    {
      '@type': 'Question',
      name: 'JK制服搭配白丝有哪些注意事项？',
      acceptedAnswer: {
        '@type': 'Answer',
        text: '注意白丝的长度选择，过膝袜是最经典的搭配；根据季节选择材质；注意色彩协调，白色丝袜搭配深色制服效果最佳。',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
      <SEOHead
        title="首页"
        description={siteInfo.description}
        keywords={siteInfo.keywords}
        canonicalUrl="https://shiroi-jk.com"
      />
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <CategoryCards />
        <FeaturedArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}